import { type KeyboardEvent } from "react";

import { SearchIcon, XIcon } from "lucide-react";
import { useSearchBox } from "react-instantsearch";

import { PrimTextField } from "@/shared-web.ui/prim.text-field";

const ProductSearch = () => {
  const { query, refine, clear } = useSearchBox();

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Escape") {
      clear();
    }
  };

  return (
    <PrimTextField.Root
      size="2"
      className={`
        max-w-48 text-3
        sm:text-2
      `}
      placeholder="Search"
      value={query}
      onChange={(e) => {
        refine(e.target.value);
      }}
      onKeyDown={handleKeyDown}
    >
      <PrimTextField.Slot side="left">
        <SearchIcon className="size-3" />
      </PrimTextField.Slot>
      {query && (
        <PrimTextField.Slot
          side="right"
        >
          <button
            type="reset"
            onClick={clear}
          >
            <XIcon className="size-3" />
          </button>
        </PrimTextField.Slot>
      )}
    </PrimTextField.Root>
  );
};

export { ProductSearch };
